export default __webpack_public_path__ + "static/media/imagine_dream_back.25cc00dc.gif";